import { useNoteAlert } from "../../../Context/pleaseNote";

export const AdminOnlyAlertPopup = () => {
  const { showModelAlert } = useNoteAlert();
  const handleShow = () => {
    showModelAlert({
      content: `<p class="text-center col-fs-14 fs-15 fw-normal">Please contact the admin user for your account to update details.</p>`,
      title: "Restricted Area",
      showCloseBtn: true,
      icon: "wes-address-home",
    });
  };
  return (
    <div className="button-effect accHeader-btn mt-2 mt-md-0">
      <button
        type="button"
        className="btn btn-products theme-primary"
        onClick={handleShow}
      >
        Update Shipping Address
      </button>
    </div>
  );
};
